import BaseDialog from "@/components/BaseDialog";

// 工单管理-待指派 撤回
export function withdrawModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./withdrawModal.vue'),
        options: {
            width: '600px',
            title: '温馨提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 工单管理- 结单
export function settleModel({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./settleModel.vue'),
        options: {
            width: '600px',
            title: '结单',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 工单管理- 删除素材
export function rejectModal({ props, cbs, on }) {
    return new BaseDialog({
        component: ()=>import('./rejectModal.vue'),
        options: {
            width: '600px',
            title: '删除素材',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        on,
    })
}

export function resultModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./resultModal.vue'),
        options: {
            width: '600px',
            title: '通过素材',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 工单管理- 批量下载
export function downLoadModal({ props, cbs, on }) {
    return new BaseDialog({
        component: ()=>import('./downLoadModal.vue'),
        options: {
            width: '600px',
            title: '批量下载',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        on
    })
}
